module.exports = __webpack_public_path__ + "fonts/Quicksand-600-latin-ext11.29b81f3.woff2";